/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable global-require */
import { fetchAllDistricts, fetchAllServices } from '../actions/district';

// The top-level (parent) route
export default {

  path: '/',

  // Keep in mind, routes are evaluated in order
  children: [
    require('./admin').default,
    require('./home').default,
    require('./services').default,
    require('./eservices').default,
    require('./panel').default,
    {
      path: '/paymentStatus', // optional
      action: async (ctx) => {
        const { query } = ctx;
        return { redirect: `/eservices/paymentStatus/${ctx.query.OrderID}?${Object.keys(ctx.query).map(key => `${key}=${ctx.query[key]}`).join('&')}`}
      },
    },
    require('./paymentStatus').default,
    require('./eserviceSummary').default,
    require('./eserviceError').default,
    require('./verifyDocument').default,
    require('./login').default,
    require('./connectPZ').default,
    require('./login/resetPassword').default,
    require('./login/confirmPassword').default,
    require('./rejestracja').default,
    require('./registerwk').default,
    // require('./contact').default,
    require('./urzad').default,
    require('./euslugi').default,
    require('./administrator').default,
    require('./district').default,
    require('./notFound').default,
  ],

  async action({ store, next }) {
    // Execute each child route until one of them return the result
    await store.dispatch(fetchAllDistricts());
    await store.dispatch(fetchAllServices());

    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Wojewódzki Ośrodek Dokumentacji Geodezyjnej i Kartograficznej'}`;
    route.description = route.description || '';

    return route;
  },

};



// WEBPACK FOOTER //
// src/routes/index.js